export const TIMEOUT_DEFAULT: number = 0;
export const TIMEOUT_MINIMAL: number = 1;
export const TIMEOUT_SHORT: number = 2000;
